export default __webpack_public_path__ + "static/media/FiaStation.dfcc3397.svg";